(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.alert = {
    attach: function (context, settings) {
      $(".alert", context).once('alert').each(function () {
        $(this).on("click", ".close", function () {
          $(this).closest(".alert").slideUp(200);
        });
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
